import React, { Component } from 'react';
import TweenMax from 'gsap';

// import TypeText from '../TypeText';

import { track } from '../../utils/analytics';

import style from './index.module.scss';

export default class Share extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    }

    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleFBClick = this.handleFBClick.bind(this);
    this.handleTWClick = this.handleTWClick.bind(this);
  }

  /* global FB */
  handleFBClick() {
    FB.ui({
      method: 'share',
      href: process.env.REACT_APP_URL
    }, response => {});
    track('clicked', 'facebook');
  }

  handleTWClick() {
    const url = process.env.REACT_APP_URL;
    const text = process.env.REACT_APP_TITLE;
    const width = 640;
    const height = 400;
    const left = window.screen.availLeft + (window.screen.availWidth - width) / 2;
    const top = window.screen.availTop + (window.screen.availHeight - height) / 2;
    track('clicked', 'twitter');
    window.open(`http://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '', `width=${width},height=${height},left=${left},top=${top}`);
  }

  handleIconEnter(which) {
    if (this.props.type === 'restart') return;
    if (which === 'facebook') TweenMax.to(this.twitter, 0.1, { opacity: 0.5, overwrite: true });
    else if (which === 'twitter') TweenMax.to(this.facebook, 0.1, { opacity: 0.5, overwrite: true });
  }

  handleIconLeave(which) {
    if (this.props.type === 'restart') return;
    if (which === 'facebook') TweenMax.to(this.twitter, 0.1, { opacity: 1, overwrite: true });
    else if (which === 'twitter') TweenMax.to(this.facebook, 0.1, { opacity: 1, overwrite: true });
  }

  handleMouseOver() {
    if (this.props.type === 'restart') return;
    track('visible', `Social menu expanded`);
    this.setState(() => ({ hovered: true }));
  }

  handleMouseOut() {
    if (this.props.type === 'restart') return;
    this.setState(() => ({ hovered: false }));
  }

  render() {
    const { useUnderline, color, className, type } = this.props;
    const placement = this.props.placement || 'header';
    const restart = type === 'restart';

    return (
      <div className={`${style.share} ${!useUnderline ? style['without-underline'] : ''} ${style[type]} ${className ? className : ''} ${style[placement]}`}
        onMouseEnter={this.handleMouseOver} onMouseLeave={this.handleMouseOut} onClick={this.props.onClick ? this.props.onClick.bind(this) : null}>
        <div className={style['results-share']} data-share-copy style={{ color }}>{restart ? 'Retake\u00A0the\u00A0Quiz' : 'Share'}</div>
        {!restart ? <div className={style['share-icons']}>
          <svg viewBox="0 0 29 29" className={`${style.icon} ${style.facebook}`} style={{ fill: color }}
            ref={instance => this.facebook = instance}
            onMouseOver={() => this.handleIconEnter('facebook')}
            onMouseOut={() => this.handleIconLeave('facebook')}
            onClick={this.handleFBClick}>
            <path d="M13,12H11v2h2v6h3V14h1.82L18,12H16v-.83c0-.48.1-.67.56-.67H18V8H15.6c-1.8,0-2.6.79-2.6,2.31Z" />
            <circle cx="14.5" cy="14.5" r="12" style={{ stroke: color }} />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" style={{ fill: color }}
            className={`${style.icon} ${style.twitter}`}
            ref={instance => this.twitter = instance}
            onMouseOver={() => this.handleIconEnter('twitter')}
            onMouseOut={() => this.handleIconLeave('twitter')}
            onClick={this.handleTWClick}>
            <circle cx="14.5" cy="14.5" r="12" style={{ stroke: color }} />
            <path d="M20.5,10.78a5.17,5.17,0,0,1-1.41.39A2.5,2.5,0,0,0,20.17,9.8a4.77,4.77,0,0,1-1.56.6,2.47,2.47,0,0,0-4.2,2.25,7,7,0,0,1-5.07-2.58,2.46,2.46,0,0,0,.76,3.29A2.41,2.41,0,0,1,9,13.05a2.49,2.49,0,0,0,2,2.45,2.58,2.58,0,0,1-1.11,0,2.46,2.46,0,0,0,2.3,1.71,5,5,0,0,1-3.65,1,7,7,0,0,0,10.77-6.22A5,5,0,0,0,20.5,10.78Z"/>
          </svg>
        </div> : null}
        { useUnderline ? <div className={style.underline} style={{ background: color }} /> : null }
      </div>
    )
  }
}

Share.defaultProps = {
  useUnderline: true
}
